import React from 'react';
import { useEffect, useState, useRef } from 'react';
import LoadingPage from "../components/Loading";
import FormDisplay from './cms/components/EventFormDisplay.js'
import Nav from './newlanding/components/Nav.js';
import Footer from './newlanding/components/Footer.js';
import { useNavigate, useParams,useSearchParams } from 'react-router-dom';
import {fetchEventById} from '../services/events.js'
const Form = ({scrollRef, handleSetRightNav}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const referType = searchParams.get('refer')
    const {id:eventId} = useParams();
    const [data, setData] = useState({});
    const [isloading, setisloading] = useState(false);
    const navigate = useNavigate();

    async function fetchDate(){
        setisloading(true)
        let result = await fetchEventById(eventId);
        if(result?.result){
            setData(result.result);
        }else{
            setData({});
            alert('無法獲取報名表資料，請稍後再試。')
        }
        setisloading(false)
    }
    useEffect(()=>{
        if(eventId.length===24){
            fetchDate()
        }
    },[eventId])

    const isMobile= window?.innerWidth<768
    const handleBack = () => {
        window?.ReactNativeWebView?.postMessage('close')
        navigate(-1)
    }

    return (
        <div className='w-full flex-col items-center relative'>
            {/* <Nav scrollRef={scrollRef} handleSetRightNav={handleSetRightNav} onlyIcon={true}/> */}
            <FormDisplay
                allowRegistration={data?.registrationForm?.enable||false}
                form={data?.registrationForm||{}}
                id={eventId}
                isApp={referType==='app'}
            />
            {referType==='app'?null:<Footer />}
            {isloading&&<LoadingPage/>}

            {/* back button only appear in mobile view, fixed at top left corner,, round, shadow */}
            {isMobile&&
            <div className='w-[40px] h-[40px] bg-[#00000080] rounded-full shadow-md flex items-center justify-center fixed top-[52px] left-[6px] z-[30] cursor-pointer' onClick={handleBack}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>}
        </div>
    );
};

export default Form;